import React, { useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { Box, Card, Container, Typography } from "@mui/material";
import preBg1 from "../../assets/prereg-bg1.png";
import preBg2 from "../../assets/prereg-bg2.png";
import { Navigate, useSearchParams } from "react-router-dom";
import { fileActions } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { CustomLoadingOverlay } from "../../components";
import { useTranslation } from "react-i18next";
import PreRegForm from "./PreRegForm";

const useStyles = makeStyles((theme) => ({
  bg1: {
    width: "100vw",
    height: "100vh",
    backgroundSize: "auto",
    backgroundRepeat: "no-repeat",
    position: "absolute",
    top: -30,
    [theme.breakpoints.only("xl")]: {
      backgroundSize: "cover",
    },
  },
  bg2: {
    width: "100vw",
    height: "100vh",
    backgroundSize: "auto",
    backgroundRepeat: "no-repeat",
    position: "absolute",
    top: -50,
    [theme.breakpoints.only("xl")]: {
      backgroundSize: "cover",
    },
  },
}));

export default function PreRegistration() {
  const classes = useStyles();
  const [searchParams] = useSearchParams();
  const file = useSelector((state) => state.FileByGUID);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // Se obtiene queryparam
  const GUID = searchParams.get("Id");

  useEffect(() => {
    if (GUID) dispatch(fileActions.GetFileByGUID({ GUID }));
  }, [GUID]);

  if (!GUID) return <Navigate to="/auth" />;

  return (
    <Box width="100vw">
      {file.loading && (
        <CustomLoadingOverlay
          active={file.loading}
          text={t("general_loading_message")}
        />
      )}
      <Box className={classes.bg1} sx={{ backgroundImage: `url(${preBg1})` }} />
      <Box className={classes.bg2} sx={{ backgroundImage: `url(${preBg2})` }} />
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {file.items && (
          <Container sx={{ zIndex: 99 }}>
            <Card
              elevation={10}
              sx={{ height: "400px", bgcolor: "white", p: 4 }}
            >
              <Typography variant="h3">{t("talent_text")}</Typography>
              <Typography>
                {
                  file.items?.Metadata.find(
                    (item) => item.Name === "NameVacante"
                  )?.Value
                }
              </Typography>
              <br />
              <Box display="flex" flexDirection="column" gap={3}>
                <Typography>
                  <b>{t("recruiter_text")}: </b>{" "}
                  {
                    file.items?.Metadata.find(
                      (item) => item.Name === "NombreReclutador"
                    )?.Value
                  }
                </Typography>
                <Typography>
                  <b>{t("work_modality_text")}: </b>{" "}
                  {
                    file.items?.Metadata.find(
                      (item) => item.Name === "ModalidadTrabajo"
                    )?.Value
                  }
                </Typography>
                <Typography>
                  <b>{t("Team_text")}: </b>{" "}
                  {
                    file.items?.Metadata.find((item) => item.Name === "Equipo")
                      ?.Value
                  }
                </Typography>
                <Typography>
                  <b>{t("start_date_text")}: </b>{" "}
                  {
                    file.items?.Metadata.find(
                      (item) => item.Name === "FechaInicioProceso"
                    )?.Value
                  }
                </Typography>
                <Typography>
                  <b>{t("end_date_text")}: </b>{" "}
                  {
                    file.items?.Metadata.find(
                      (item) => item.Name === "FechaFinProceso"
                    )?.Value
                  }
                </Typography>
              </Box>
              <Box display="flex" justifyContent="center" mt={2}>
                <PreRegForm />
              </Box>
            </Card>
          </Container>
        )}
      </Box>
    </Box>
  );
}
